document.addEventListener('DOMContentLoaded', () => {
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    const moreBtn = document.querySelector('[data-search-submit]');
    let timer;

    if (!input || !results) return;

    input.addEventListener('input', () => {
        clearTimeout(timer);
        const query = input.value.trim();

        if (query.length < 2) {
            results.innerHTML = '';
            if (moreBtn) {
                moreBtn.style.display = 'none'; // Скрываем кнопку, если запрос стерт
                moreBtn.href = `${window.location.origin}/?s=`;
            }
            return;
        }

        timer = setTimeout(async () => {
            const formData = new FormData();
            formData.append('action', 'ajax_search_articles');
            formData.append('query', query);
            formData.append('nonce', window.ajax_params.nonce);

            results.style.opacity = '0.5';

            try {
                const response = await fetch(window.ajax_params.ajax_url, {
                    method: 'POST',
                    body: formData
                });

                const res = await response.json();

                if (res.success) {
                    // Вставляем результат (карточки или "пусто")
                    results.innerHTML = res.data.html;
                    
                    // Управляем кнопкой "Більше статей"
                    if (moreBtn) {
                        if (res.data.show_button) {
                            moreBtn.style.display = 'inline-flex'; // Показываем, если есть еще статьи
                            moreBtn.href = `${window.location.origin}/?s=${encodeURIComponent(query)}`;
                        } else {
                            moreBtn.style.display = 'none'; // Скрываем, если статей <= 5
                        }
                    }
                }
            } catch (error) {
                console.error('Search Error:', error);
            } finally {
                results.style.opacity = '1';
            }
        }, 400);
    });
});